module.exports = __webpack_public_path__ + "img/trial1-3.f1df4500.png";